/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environmentProd = {
  production: true,
  env: 'production',
  backend: 'https://app.storydoc.com/api',
  stories: 'https://www.storydoc.com',
  assets: 'https://www-staging.storydoc.com/assets/editor',
  oktaAppId: '0oa4zshf7tQtqFMop5d6',
  assetsLink: 'https://editor-bundle-staging.storydoc.com',
  frontPublicUrl: 'https://www-staging.storydoc.com/assets/editor'
};
